import React, { ReactElement, Component, useContext, useEffect, ChangeEvent, SyntheticEvent, useState } from 'react';
// import FilterViewerTable from './FilterViewer';

import { useSelector } from 'react-redux';
import FilterViewerTable from './FilterViewer';
import AddCategoryLink from './AddBrandLink';
import ProductContext from '../memory/CategoryContext';

const FilteredDataProvider: React.FC<any> = (props: any) => {
  const { isOpen } = useSelector((state: any) => state.SidebarState);

  return (
    <ProductContext.Consumer>
      {(context) => (
        <>
          <div className="flex justify-end items-end xl:flex-row flex-col-reverse my-4 gap-2 p-2.5">
          
            <div className={`flex xs:justify-end gap-2 max-lg:w-full mdx:flex-row flex-col ${isOpen ? 'lg:flex-row md:flex-col' : ''}`}>

              <div className={`flex flex-row justify-end gap-2 mxs:gap-2.5 ${isOpen ? 'justify-end' : 'md:max-xl:flex-col'}`}>
                {/* put date Range selector here */}

             
                <AddCategoryLink />
              </div>
            </div>
          </div>
        </>
      )}
    </ProductContext.Consumer>
  );
};

export default FilteredDataProvider;
